<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10" @close="hide">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel class="dialog-panel">
              <article>
                <DialogTitle as="h3" class="dialog-title">
                  Wo stehst du mit deinen übergeordneten Podcast-Zielen?
                </DialogTitle>
                <EvaluationForm :resource="resource" :errors="errors" :metrics="metrics" />
              </article>
              <div class="mt-5 sm:mt-6 flex justify-end">
                <CancelButton @click="onCancel" class="mr-2">
                  Abbrechen
                </CancelButton>
                <SubmitButton @click="onSubmit" :load="creating">
                  Jetzt erfassen
                </SubmitButton>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useCreateResource } from '@/client/actions';

const props = defineProps({experiment: Object});
const emits = defineEmits(['submit', 'cancel']);

const open = ref(false);
const show = () => open.value = true;
const hide = () => open.value = false;
const toggle = () => open.value = ! open.value;

const context = computed(() => props.experiment.podcast);
const metrics = computed(() => context.value.traceable ?? []);

const parent = computed(() => context.value.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/metrics');
const action = useCreateResource(target);

const { resource, create, creating, errors } = action;

const onCancel = () => hide();
const onSuccess = () => hide();
const onSubmit = () => create(onSuccess);

defineExpose({show, hide, toggle});
</script>

<style scoped>
.dialog-panel
{
  @apply relative transform;
  @apply rounded-lg bg-white shadow-xl;
  @apply px-4 pt-5 pb-4;
  @apply sm:my-8 sm:w-full sm:max-w-6xl sm:p-6;
  @apply text-left transition-all;
};

.dialog-title
{
  @apply text-lg text-gray-900;
  @apply leading-6;
  @apply font-medium;
};
</style>
